import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { CommentDto, SaveCommentDto, SaveProjectCommentDto } from '@models/comment';
import { ModelType } from '@shared/constants/model-type.enum';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  readonly commentUrl: string = 'comment';
  readonly projectCommentUrl: string = 'comment-project';   
  constructor(private apiService: ApiService
  ) { }

  getCommentData(treeId: number, modelType: ModelType): Observable<CommentDto[]> {
    const url = `${this.commentUrl}/${treeId}`;
    return this.apiService.get(url, modelType);
  }

  getProjectCommentData(projectId: number, modelType: ModelType): Observable<CommentDto[]> {
    const url = `${this.projectCommentUrl}/${projectId}`;
    return this.apiService.get(url, modelType);
  }
  
  saveCommentData(comment: SaveCommentDto, modelType: ModelType) {
    return this.apiService.post(this.commentUrl, comment, modelType);
  }

  saveProjectCommentData(comment: SaveProjectCommentDto, modelType: ModelType) {
    return this.apiService.post(this.projectCommentUrl, comment, modelType);
  }
}